import { Link as RouterLink, useHistory } from 'react-router-dom';
import {
    Box,
    Divider,
    Grid,
    Link,
    IconButton,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    link: {
        marginLeft: theme.spacing(10),
        color: theme.palette.info.dark,
    },
    line: {
        marginTop: theme.spacing(2),
    },
    content: {
        padding: theme.spacing(2),
    }
}));

export default function OrgNav({ orgInfo }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();

    if (orgInfo.orgId === "") {
        return (
            <Grid
                container
                alignItems='stretch'
                direction='column'
                justify='flex-start'
                className={classes.content}>
                <Grid item xs>
                    <Box border={2} borderColor='error.main'>
                        <Typography align='center' color='error'>
                            {t("youAreNotCurrentlyConnected")}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs
                    className={classes.line}>
                    <Link className={classes.link}
                        variant='h5'
                        component={RouterLink}
                        to={'/orgs/'.concat('new')}>
                        {t("createOrganization")}
                    </Link>
                </Grid>
            </Grid>
        )
    }
    return (
        <Grid
            container
            alignItems='stretch'
            direction='column'
            justify='flex-start'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    <Tooltip title={t("goHome")}>
                        <IconButton color='primary'
                            onClick={() => history.push("/")}>
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>
                    <Typography variant='h5'
                        color='textPrimary'>
                        Account Settings
                    </Typography>
                </Toolbar>
            </Grid>
            <Grid item xs><Divider /></Grid>
            <Grid item xs
                className={classes.line}>
                <Link className={classes.link}
                    variant='h5'
                    component={RouterLink}
                    to={'/orgs/'.concat(orgInfo.orgName).concat('/details')}>
                    Details
                </Link>
            </Grid>
            <Grid item xs
                className={classes.line}>
                <Link className={classes.link}
                    variant='h5'
                    component={RouterLink}
                    to={'/orgs/'.concat(orgInfo.orgName).concat('/manage')}>
                    {t("manageOrg")}
                </Link>
            </Grid>
            <Grid item xs
                className={classes.line}>
                <Link className={classes.link}
                    variant='h5'
                    component={RouterLink}
                    to={'/orgs/'.concat(orgInfo.orgName).concat('/billing')}>
                    {t("deviceBilling")}
                </Link>
            </Grid>
            <Grid item xs
                className={classes.line}>
                <Link className={classes.link}
                    variant='h5'
                    component={RouterLink}
                    to={'/orgs/'.concat(orgInfo.orgName).concat('/fluids')}>
                    {t("fluids")}
                </Link>
            </Grid>
        </Grid>
    )
}
